import { makeStyles } from '@material-ui/core/styles';
import { wppColors } from '../../../App.styles';
import profileAvatar from '../../images/wpp/WPPOpen_Bee-01.png';

export const useStyles = makeStyles((theme) => ({
  header:{
    position: 'relative',
    // Mobile: hamburger | centred logo | profile. The 1fr side columns keep the
    // logo optically centred regardless of how wide each side control is.
    display: 'grid',
    gridTemplateColumns: '1fr auto 1fr',
    alignItems: 'center',
    gap: '8px',
    width: '100%',
    height: '64px',
    padding: '0 12px',
    boxSizing: 'border-box',

    background: '#F5F5F5',
    boxShadow: 'none',
    zIndex: 3,

    [theme.breakpoints.up('medium')]: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      gap: '10px',
      padding: '0 24px',
    },
  },

  expand_collapse_button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    justifySelf: 'start',
    height: '36px',
    width: '36px',
    padding: 0,
    borderRadius: '999px',
    backgroundColor: 'transparent',
    border: 0,
    outline: 'none',
    cursor: 'pointer',
    flexShrink: 0,

    '&:hover': {
      backgroundColor: '#E9EBEF',
    },

    // Desktop shows the full tab bar, so the toggle is only needed on mobile
    [theme.breakpoints.up('medium')]: {
      display: 'none',
    },
  },

  expand_collapse_icon: {
    width: '24px',
    height: '24px',
    fill: 'none',

    // menu-bars.svg hardcodes stroke="white" on its paths, so override it here
    '& path': {
      stroke: wppColors.navy,
    },
  },

  branding: {
    display: 'flex',
    alignItems: 'center',
    justifySelf: 'center',
    minWidth: 0,

    [theme.breakpoints.up('medium')]: {
      marginLeft: '32px',
      marginRight: 'auto',
    },
  },

  logo: {
    height: '26px',
    width: 'auto',
    flexShrink: 0,

    [theme.breakpoints.up('medium')]: {
      height: '38px',
    },
  },

  appName: {
    color: wppColors.navy,
    fontSize: '13px',
    fontFamily: "'WPP', Arial, sans-serif",
    fontWeight: 700,
    lineHeight: '24px',
    letterSpacing: '0.5px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    [theme.breakpoints.up('medium')]: {
      fontSize: '16px',
    },
  },

  header_right: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifySelf: 'end',
    flexShrink: 0,
    gap: '6px',

    [theme.breakpoints.up('medium')]: {
      gap: '15px',
    },
  },

  profile_button: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '4px',
    backgroundColor: 'transparent',
    border: '1px solid transparent',
    borderRadius: '999px',
    outline: 'none',
    cursor: 'pointer',
    transition: 'background-color 0.15s ease, border-color 0.15s ease',

    [theme.breakpoints.up('medium')]: {
      padding: '4px 10px 4px 4px',
    },

    '&:hover': {
      backgroundColor: '#E9EBEF',
      borderColor: '#D6D6D6',
    },

    '&:focus-visible': {
      borderColor: wppColors.navy,
      boxShadow: '0 0 0 3px rgba(0, 0, 80, 0.16)',
    },
  },

  profile_button_active: {
    backgroundColor: 'rgba(0, 0, 80, 0.06)',
    borderColor: 'transparent',

    '&:hover': {
      backgroundColor: 'rgba(0, 0, 80, 0.12)',
      borderColor: 'transparent',
    },
  },

  profile_avatar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    flexShrink: 0,
    backgroundColor: wppColors.white,
    backgroundImage: `radial-gradient(circle, rgba(255,255,255,0.55) 0%, rgba(255,255,255,0.35) 45%, rgba(255,255,255,0) 70%), url(${profileAvatar})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    color: wppColors.navy,
    fontSize: '12px',
    fontWeight: 700,
    letterSpacing: '0.5px',
    fontFamily: "'WPP', Arial, sans-serif",
  },

  user_label: {
    display: 'none',
    fontSize: '16px',
    fontFamily: "'WPP', Arial, sans-serif",
    fontWeight: 400,
    lineHeight: '22.4px',
    color: '#191919',
    margin: 0,

    [theme.breakpoints.up('medium')]: {
      display: 'block',
    },
  },
  
  logout_button: {
    display: 'none',
    alignItems: 'center',
    gap: '8px',
    padding: '4px',
    backgroundColor: '#F5F5F5',
    border: 0,
    outline: 'none',
    cursor: 'pointer',
    flexShrink: 0,
    transition: 'background-color 0.15s ease',

    '&:hover': {
      backgroundColor: '#E5E5E5',
    },

    // On mobile the logout action lives inside the hamburger menu
    [theme.breakpoints.up('medium')]: {
      display: 'flex',
    },
  },

  logout_label: {
    color: '#303030',
    fontSize: '16px',
    fontFamily: "'WPP', Arial, sans-serif",
    fontWeight: 400,
    lineHeight: '16px',
    whiteSpace: 'nowrap',

    [theme.breakpoints.down(768)]: {
      display: 'none',
    },
  },

  log_out_icon: {
    width: '24px',
    height: '24px',
    filter: 'brightness(0)',
  },

}));